"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithHyperlink = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importStar(require("react"));
var ternary_lint_util_1 = require("../../utils/ternary-utils/ternary-lint-util");
var icon_with_hyperlink_styles_1 = require("./icon-with-hyperlink.styles");
var IconWithHyperlink = function (_a) {
    var id = _a.id, className = _a.className, icon = _a.icon, label = _a.label, onClick = _a.onClick, ariaLabel = _a.ariaLabel, uppercase = _a.uppercase, underline = _a.underline, disabled = _a.disabled, primary = _a.primary, secundary = _a.secundary, bgColor = _a.bgColor, dataElement = _a.dataElement, gaProps = __rest(_a, ["id", "className", "icon", "label", "onClick", "ariaLabel", "uppercase", "underline", "disabled", "primary", "secundary", "bgColor", "dataElement"]);
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var setStrokeColor = function () {
        return disabled ? theme.p003 : (0, ternary_lint_util_1.retornaValorCondicionado)(secundary, theme.grey003, theme.p001);
    };
    var icone = (0, react_1.cloneElement)(icon, {
        stroke: setStrokeColor(),
        className: 'icon',
    });
    return (react_1.default.createElement(icon_with_hyperlink_styles_1.S.IconWithHyperlink, { className: className, "data-testid": "section-icon-with-hyperlink" },
        react_1.default.createElement(icon_with_hyperlink_styles_1.S.Button, __assign({ id: id, "data-testid": "btn-icon-with-hyperlink", "aria-label": ariaLabel || label }, gaProps, { onClick: onClick, primary: primary, secundary: secundary, disabled: disabled, "data-element": dataElement }),
            icone,
            react_1.default.createElement(icon_with_hyperlink_styles_1.S.Text, null,
                react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small", bgColor: bgColor }, label)))));
};
exports.IconWithHyperlink = IconWithHyperlink;
